import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import PosVolumeReportTableFilter from "../Filters/PosVolumeReportTableFilter";
import { ColumnHelper } from "util/TableHelper";

import { Table, Empty, Col, Row, notification, Tooltip, Spin } from "antd";
import { lowerCase } from "lodash";
import { InfoCircleOutlined } from "@ant-design/icons";

const detailTableGroupedByBankId = (detail) => {
  let data = [];

  if (detail.length > 0) {
    data = detail[0].data;
  }

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      render: (data, row) => {
        const totals = row.amountDetails.reduce((acc, item) => {
          if (!acc[item.type]) {
            acc[item.type] = 0;
          }
          acc[item.type] += item.amount;
          return acc;
        }, {});

        const resultString = Object.entries(totals)
          .map(
            ([type, amount]) =>
              `${type} Tutarı: ${ColumnHelper.renderDecimal(amount)}`
          )
          .join("\n");

        return (
          <div>
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>{resultString}</span>
              }
            >
              <InfoCircleOutlined />
            </Tooltip>{" "}
            {ColumnHelper.renderDecimal(data)}{" "}
          </div>
        );
      },
    },
    {
      title: "Komisyon Tutarı",
      dataIndex: "commissionAmount",
      render: (data, row) => {
        const totals = row.amountDetails.reduce((acc, item) => {
          if (!acc[item.type]) {
            acc[item.type] = 0;
          }
          acc[item.type] += item.commissionAmount;
          return acc;
        }, {});

        const resultString = Object.entries(totals)
          .map(
            ([type, amount]) =>
              `${type} Komisyonu: ${ColumnHelper.renderDecimal(amount)}`
          )
          .join("\n");

        return (
          <div>
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>{resultString}</span>
              }
            >
              <InfoCircleOutlined />
            </Tooltip>{" "}
            {ColumnHelper.renderDecimal(data)}{" "}
          </div>
        );
      },
    },
    {
      title: "Komisyon Oranı(%)",
      dataIndex: "commissionRate",
      render: ColumnHelper.renderCommissionateDecimal,
    },
    {
      title: "Net Tutar",
      dataIndex: "netAmount",
      render: ColumnHelper.renderDecimal,
    },
  ];
  return (
    <Table
      columns={columns}
      locale={{
        emptyText: (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" />
        ),
      }}
      expandable={{
        expandedRowRender: (row) =>
          detailTableGroupedByMemberWorkPlace(row.details),
        rowExpandable: (row) => row.details ?? false,
      }}
      rowKey={(record) => record.bankId}
      filterable={true}
      sortable={true}
      pagination={false}
      dataSource={data}
      size="small"
    />
  );
};

const detailTableGroupedByMemberWorkPlace = (data) => {
  const columns = [
    {
      title: "Üye iş Yeri No",
      dataIndex: "memberWorkplaceNumber",
    },
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Komisyon Tutarı",
      dataIndex: "commissionAmount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Komisyon Oranı(%)",
      dataIndex: "commissionRate",
      render: ColumnHelper.renderCommissionateDecimal,
    },
    {
      title: "Net Tutar",
      dataIndex: "netAmount",
      render: ColumnHelper.renderDecimal,
    },
  ];
  return (
    <Table
      columns={columns}
      locale={{
        emptyText: (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" />
        ),
      }}
      expandable={{
        expandedRowRender: (row) => detailTableGroupedByTerminal(row.details),
        rowExpandable: (row) => row.details ?? false,
      }}
      rowKey={(record) => record.memberWorkplaceNumber}
      filterable={true}
      sortable={true}
      pagination={false}
      dataSource={data}
      size="small"
    />
  );
};

const detailTableGroupedByTerminal = (data) => {
  const columns = [
    {
      title: "Terminal Numarası",
      dataIndex: "terminalNumber",
    },
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Komisyon Tutarı",
      dataIndex: "commissionAmount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Komisyon Oranı(%)",
      dataIndex: "commissionRate",
      render: ColumnHelper.renderCommissionateDecimal,
    },
    {
      title: "Net Tutar",
      dataIndex: "netAmount",
      render: ColumnHelper.renderDecimal,
    },
  ];
  return (
    <Table
      columns={columns}
      locale={{
        emptyText: (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" />
        ),
      }}
      rowKey={(record) => record.terminalNumber}
      filterable={true}
      sortable={true}
      pagination={false}
      dataSource={data}
      size="small"
    />
  );
};

const PosVolumeReportDaily = (props) => {
  const defaultQueryData = {
    pageSize: 15,
  };
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [filterDay, setFilterDay] = useState("30");

  const [tableDataQueryOptions, setTableDataQueryOptions] =
    useState(defaultQueryData);

  const [loadingIds, setLoadingIds] = useState([]);
  const [expandedData, setExpandedData] = useState([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const tenantId = localStorage.getItem("tenantId");

  useEffect(() => {
    getTableData();
    setExpandedData([]);
    setLoadingIds([]);
    setExpandedRowKeys([]);
  }, [
    tableDataQueryOptions.bankId,
    tableDataQueryOptions.endDate,
    tableDataQueryOptions.installmentCountEnd,
    tableDataQueryOptions.installmentCountStart,
    tableDataQueryOptions.startDate,
    tableDataQueryOptions.totalCommissionAmountEnd,
    tableDataQueryOptions.totalCommissionAmountStart,
    tableDataQueryOptions.valueEndDate,
    tableDataQueryOptions.valueStartDate,
  ]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    if (
      lowerCase(tenantId) ==
        lowerCase("FEBB740F-8CA4-EE11-BF1B-0050569D6B4F") &&
      moment(tableDataQueryOptions.endDate).diff(
        tableDataQueryOptions.startDate,
        "days"
      ) > 6
    ) {
      notification.error({
        message: "Tarih aralıkları arasında 7 günden fazla fark olamaz.",
        duration: 3,
      });
      setTableData({
        data: [],
        total: 0,
        loading: false,
      });
    } else {
      RequestHandler.post(
        `/PosTransaction/DailyPosVolumeReport`,
        tableDataQueryOptions,
        false
      ).then((response) => {
        setTableData({
          data: response.value,
          total: response.totalCount,
          totalRow: response.totalRow,
          loading: false,
        });
      });
    }

    if (props.onFilterChange) {
      props.onFilterChange(tableDataQueryOptions);
    }
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        pageSize: p.pageSize,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions(defaultQueryData);
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        ...query,
      };
    });
  };

  const handleMemberWorkPlaceExpand = (expanded, record) => {
    const detailData = expandedData.filter((x) => x.recordId === record.date);

    if (expanded && detailData.length <= 0) {
      setLoadingIds((prev) => [...prev, record.date]);

      tableDataQueryOptions.detailDate = record.date;

      RequestHandler.post(
        `/PosTransaction/DailyPosVolumeReportDetail`,
        tableDataQueryOptions,
        false
      ).then((response) => {
        setExpandedData((prevState) => [
          ...prevState,
          { data: response, recordId: record.date },
        ]);

        setLoadingIds((prev) => prev.filter((id) => id !== record.date));
      });
    }
  };

  const columns = [
    {
      title: "İşlem Tarihi",
      dataIndex: "date",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      render: (data, row) => {
        const totals = row.amountDetails.reduce((acc, item) => {
          if (!acc[item.type]) {
            acc[item.type] = 0;
          }
          acc[item.type] += item.amount;
          return acc;
        }, {});

        const resultString = Object.entries(totals)
          .map(
            ([type, amount]) =>
              `${type} Tutarı: ${ColumnHelper.renderDecimal(amount)}`
          )
          .join("\n");

        return (
          <div>
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>{resultString}</span>
              }
            >
              <InfoCircleOutlined />
            </Tooltip>{" "}
            {ColumnHelper.renderDecimal(data)}{" "}
          </div>
        );
      },
    },
    {
      title: "Komisyon Tutarı",
      dataIndex: "commissionAmount",
      render: (data, row) => {
        const totals = row.amountDetails.reduce((acc, item) => {
          if (!acc[item.type]) {
            acc[item.type] = 0;
          }
          acc[item.type] += item.commissionAmount;
          return acc;
        }, {});

        const resultString = Object.entries(totals)
          .map(
            ([type, amount]) =>
              `${type} Komisyonu: ${ColumnHelper.renderDecimal(amount)}`
          )
          .join("\n");

        return (
          <div>
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>{resultString}</span>
              }
            >
              <InfoCircleOutlined />
            </Tooltip>{" "}
            {ColumnHelper.renderDecimal(data)}{" "}
          </div>
        );
      },
    },
    {
      title: "Komisyon Oranı(%)",
      dataIndex: "commissionRate",
      render: ColumnHelper.renderCommissionateDecimal,
    },
    {
      title: "Net Tutar",
      dataIndex: "netAmount",
      render: ColumnHelper.renderDecimal,
    },
  ];

  return (
    <>
      <PosVolumeReportTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
        extraText={`Varsayılan olarak bugünden itibaren son ${filterDay} günlük veri
        listelenmektedir.`}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            expandable={{
              expandedRowRender: (row) =>
                loadingIds.includes(row.date) ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Spin size="small" />
                  </div>
                ) : (
                  detailTableGroupedByBankId(
                    expandedData.filter((x) => x.recordId === row.date)
                  )
                ),
              expandedRowKeys: expandedRowKeys,
              onExpandedRowsChange: (keys) => setExpandedRowKeys(keys),
              onExpand: handleMemberWorkPlaceExpand,
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(record, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.pageSize,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              server: false,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
            summary={() => {
              if (!tableData.totalRow) return;

              const { amount, commissionAmount, netAmount } =
                tableData.totalRow;
              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>Toplam:</Table.Summary.Cell>
                  <Table.Summary.Cell>
                    {ColumnHelper.renderDecimal(amount)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell colSpan={2}>
                    {ColumnHelper.renderDecimal(commissionAmount)}
                  </Table.Summary.Cell>
                  <Table.Summary.Cell>
                    {ColumnHelper.renderDecimal(netAmount)}
                  </Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default PosVolumeReportDaily;
